import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-timer",
  class WyattTimer extends WYATTElement {
    constructor() {
      super();

      this.eventDateTimeString =
        this.querySelector("[datetime]").getAttribute("datetime");
      this.eventLocalTime =
        new Date(this.eventDateTimeString).getTime() + this.getEasternOffset();

      const interval = setInterval(() => {
        const nowLocalTime = new Date().getTime();
        const timeUntilEvent = this.eventLocalTime - nowLocalTime;
        const timeData = {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };

        if (timeUntilEvent > 0) {
          timeData.days = Math.floor(timeUntilEvent / (1000 * 60 * 60 * 24));
          timeData.hours = Math.floor(
            (timeUntilEvent % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          );
          timeData.minutes = Math.floor(
            (timeUntilEvent % (1000 * 60 * 60)) / (1000 * 60),
          );
          timeData.seconds = Math.floor((timeUntilEvent % (1000 * 60)) / 1000);

          this.updateDOM(timeData);
        } else {
          clearInterval(interval);
          this.updateDOM(timeData);
          this.handleComplete();
        }
      }, 1000);
    }

    updateDOM(timeData) {
      Object.keys(timeData).forEach((key) => {
        const element = this.querySelector(`[data-value="${key}"]`);

        element.textContent = timeData[key];
      });
    }

    handleComplete() {
      if (this.config.hideOnComplete) {
        this.classList.add("timer--complete");
      }

      if (this.config.messageOnComplete) {
        this.querySelector("[data-message]").innerHTML =
          this.config.messageOnComplete;
      }
    }

    getEasternOffset() {
      const localDate = new Date();
      const stdTimezoneOffset = () => {
        const jan = new Date(0, 1);
        const jul = new Date(6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
      };
      const observingDaylightSavingTime =
        localDate.getTimezoneOffset() < stdTimezoneOffset();

      return observingDaylightSavingTime ? 4 * 3600000 : 5 * 3600000;
    }
  },
);
